export default __webpack_public_path__ + "static/media/logo-footer.ce867965.png";